import { useTranslation } from 'react-i18next';

const valueItems = [
  'value.item1',
  'value.item2',
  'value.item3',
  'value.item4',
  'value.item5',
  'value.item6',
  'value.item7',
  'value.item8',
];

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t('whatis.title')}</h2>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">{t('whatis.p1')}</p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">{t('whatis.p2')}</p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">{t('whatis.p3')}</p>
          </div>

          <div className="rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">{t('value.title')}</h3>
            <p className="mt-2 text-sm text-foreground-600">{t('value.subtitle')}</p>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {valueItems.map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-foreground-800">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {t(item)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}